<template>
  <page-section
    :section-name="name"
    :content="textContent"
    v-slot="{ content }"
  >
    <h2 class="lowercase text-green">{{ content.title }}</h2>
    <by-the-numbers
      v-for="(entry, index) of content.byTheNumbers"
      :key="`by-the-numbers-${index}`"
      :fact="index"
      :no-icon="noIcons.includes(index)"
      :no-background="noBackgrounds.includes(index)"
      class="py-2 md:py-5"
    />
  </page-section>
</template>

<script>
export default {
  name: "AtAGlance",
  components: {
    pageSection: () => import("@/components/PageSection.vue"),
    byTheNumbers: () => import("@/components/ByTheNumbers.vue"),
  },
  data() {
    return {
      name: "atAGlance",
      noIcons: [],
      noBackgrounds: ["28Visits", "2InterParesCounterparts", "1000Farmers"],
    };
  },
  computed: {
    textContent() {
      const { name } = this;

      return this.$t(`i18nSections.${name}`);
    },
  },
};
</script>
